import { useState } from 'react';
import { Header, Modal } from 'semantic-ui-react';

function OfflineDetector() {
  const [open, setOpen] = useState(true);
  return (
    <>
      <Modal onOpen={() => setOpen(true)} open={open}>
        <Modal.Header>No Connection</Modal.Header>
        <Modal.Content image>
          <Modal.Description>
            {/* <img
            width={"100px"}
            height={"100px"}
            style={{display: "block",marginLeft: "auto",marginRight: "auto",textAlign: "center",alignItems: "center",justifyContent: "center"}}
           src={"/assets/noWifi.svg"} 
           alt="Offline Image"
           /> */}
            <svg
              style={{
                width: '100px',
                height: '100px',
                display: 'flex',
                margin: '0 auto',
              }}
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="400"
              height="400"
              viewBox="0, 0, 400,400"
            >
              <g id="svgg">
                <path
                  id="path0"
                  d="M271.345 27.634 C 191.993 62.184,207.926 188.625,293.453 203.075 C 400.664 221.188,445.950 69.118,345.805 27.275 C 320.379 16.652,296.302 16.768,271.345 27.634 M90.625 77.367 C 31.393 96.398,0.000 119.296,0.000 143.469 C 0.000 179.708,25.576 183.892,78.125 156.250 C 108.072 140.497,120.911 137.498,158.447 137.485 L 203.125 137.469 203.125 104.672 L 203.125 71.875 159.375 70.605 C 135.313 69.906,104.375 72.949,90.625 77.367 M319.323 91.942 C 333.711 82.956,341.825 90.383,331.375 102.974 C 325.001 110.655,325.001 114.345,331.375 122.026 C 341.693 134.458,334.368 141.618,321.909 131.278 C 313.961 124.682,310.197 125.147,300.503 133.920 C 285.075 147.882,275.964 134.950,290.170 119.252 C 299.204 109.270,299.279 107.182,290.851 100.188 C 285.646 95.868,283.096 89.570,285.183 86.192 C 287.455 82.517,292.792 83.863,298.472 89.543 C 305.878 96.950,310.460 97.477,319.323 91.942 M128.524 194.731 C 75.079 202.640,47.756 235.849,72.341 263.015 C 85.632 277.701,93.313 277.889,131.135 264.456 C 158.988 254.563,162.530 254.563,188.433 264.456 C 223.776 277.953,233.100 277.722,246.409 263.015 C 282.360 223.289,211.788 182.411,128.524 194.731 M135.344 323.930 C 114.947 346.467,130.562 381.250,161.075 381.250 C 175.302 381.250,193.750 359.839,193.750 343.328 C 193.750 316.859,153.762 303.578,135.344 323.930 "
                  stroke="none"
                  fill="#000000"
                  fill-rule="evenodd"
                ></path>
              </g>
            </svg>
            <Header
              content="No Connection"
              style={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            />
            <Header
              content="Please check your internet connection"
              style={{
                textAlign: 'center',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            />
          </Modal.Description>
        </Modal.Content>
      </Modal>
    </>
  );
}

export default OfflineDetector;
